<template>
  <registration-progress :completed="stage === 'PAYMENT_INFORMATION'" />
  <div
    v-if="stage === 'PAYMENT_INFORMATION'"
    class="back-to-details"
    @click="setStage('CUSTOMER_INFORMATION')"
  >
    <p><i class="arrow" /> back to details</p>
  </div>
  <div class="form-container">
    <div class="form">
      <customer-form
        v-if="stage === 'CUSTOMER_INFORMATION'"
        :preview="preview"
        :countries="countries"
        :merchant="merchant"
      />
      <stripe-form
        v-if="stage === 'PAYMENT_INFORMATION'"
        :merchant-account-id="merchantAccountId"
        :available-billing-periods="availableBillingPeriods"
        :merchant="merchant"
        :preview="preview"
      />
    </div>
    <registration-icons
      v-if="!merchant"
      :stage="stage"
    />
  </div>
</template>

<script>
import CustomerForm from '../forms/CustomerForm.vue';
import StripeForm from '../forms/StripeForm.vue';
import RegistrationIcons from './RegistrationIcons.vue'
import RegistrationProgress from "./RegistrationProgress";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    RegistrationProgress,
    CustomerForm,
    StripeForm,
    RegistrationIcons,
  },
  props: {
    preview: {
      type: Boolean,
      default: false,
    },
    countries: {
      type: Object,
      required: true,
    },
    merchant: {
      type: Boolean,
      default: false,
      required: false,
    },
    merchantAccountId: {
      type: String,
      default: null,
      required: false,
    },
    availableBillingPeriods: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('registration', [
      'stage',
    ]),
  },
  methods: {
    ...mapActions('registration', [
      'setStage',
    ]),
  }
}
</script>

<style scoped>
.back-to-details {
  align-self: normal;
  cursor: pointer;
}

.form-container {
  display: flex;
  width: 100%;
  gap: 3rem;
}

.form {
  display: flex;
  flex: 1;
  flex-direction: column;
  background: #FFFFFF;
  gap: 1rem;
}

.form-navigation {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.form-navigation p {
  cursor: pointer;
}

.arrow {
  border: solid black;
  border-width: 0 3px 3px 0;
  display: inline-block;
  padding: 3px;
  transform: rotate(135deg);
}

@media only screen and (max-width: 900px) {
  .form-container {
    flex-direction: column;
  }
}
</style>
